export default "__VITE_ASSET__COrBV1gZ__"